import css from './MobileScreenshotsSection.module.css';
import { Badge, Card, Container, Grid, Heading, SimpleGrid, Text, Wrap } from '@chakra-ui/react';
import classnames from 'classnames';

const MobileScreenshotsSection = () => {
  const features = [
    {
      title: "Discover what's nearby",
      content: 'See all gyms, sports clubs, classes, and trainers around you in one scroll.',
      img:
        'https://sharetribe-assets.imgix.net/65858d03-fc00-4775-b139-7222ddac269e/raw/9b/8de46524d1704dbde7724b8acc961bd71728a7?auto=format&fit=clip&h=3600&w=3600&s=8292aab84889a6b98f92982f01047c93',
    },
    {
      title: 'Match your vibe',
      content: 'Discover workouts and instructors that fit your style and energy.',
      img:
        'https://sharetribe-assets.imgix.net/65858d03-fc00-4775-b139-7222ddac269e/raw/b4/7432bd84903ada9ed38814e4344c5638dbfbb0?auto=format&fit=clip&h=3600&w=3600&s=8786a0f0069a8112c2b36547707fdeae',
    },
    {
      title: 'Find your fit',
      content: 'Filter by price, goals, and preferences to pick what works for you.',
      img:
        'https://sharetribe-assets.imgix.net/65858d03-fc00-4775-b139-7222ddac269e/raw/4e/7141953c3cb6b794124b50df3fad4b76193888?auto=format&fit=clip&h=3600&w=3600&s=975ac0d99060340f2eddd52eddb95f76',
    },
  ];

  return (
    <section id="mobile-screenshots" className={css.appWrapper}>
      <Container maxW={'5xl'}>
        <Badge size="md" colorPalette="purple" variant="surface">
          Meet <span className={css.footfallLogo}>FootFall</span>
        </Badge>
        <Heading
          size={{
            base: '3xl',
            lg: '5xl',
          }}
          fontWeight={'bold'}
        >
          Your local fitness scene
        </Heading>
        <Text
          fontSize={{
            base: 'md',
            lg: 'lg',
          }}
          fontWeight="medium"
          color={'lightGreyText'}
          styles={{ mb: '3rem' }}
        >
          Tired of juggling ten tabs? We've combined your whole fitness scene in one scroll — from
          rugby clubs to boutique gyms, everything nearby is in a single search.
        </Text>
        <SimpleGrid columns={{ base: 3, mdDown: 1 }} gap="4rem" mt={'4rem'}>
          {features.map((feature, index) => (
            <div key={index} className={classnames({ [css.middleItem]: index === 1 })}>
              <Card.Root className={css.card}>
                <img src={feature.img} alt={feature.title} className={css.cardImage} />
              </Card.Root>
              <Heading
                size={{
                  base: 'sm',
                  lg: 'md',
                }}
                fontWeight={'bold'}
                as={'h4'}
                mt={'1em'}
                mb={0}
              >
                {feature.title}
              </Heading>
              <Text
                fontSize={{
                  base: 'sm',
                  lg: 'md',
                }}
                mt={0}
              >
                {feature.content}
              </Text>
            </div>
          ))}
        </SimpleGrid>
      </Container>
    </section>
  );
};
export default MobileScreenshotsSection;
